var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 37.5v2.8125c0 .932-.7555 1.6875-1.6875 1.6875H9.9375c-.93199 0-1.6875-.7555-1.6875-1.6875v-25.875c0-.932.75551-1.6875 1.6875-1.6875H15v20.8125c0 2.1712 1.7663 3.9375 3.9375 3.9375H30.75zm0-24.1875V6H18.9375c-.932 0-1.6875.75551-1.6875 1.6875v25.875c0 .932.7555 1.6875 1.6875 1.6875h19.125c.932 0 1.6875-.7555 1.6875-1.6875V15h-7.3125c-.9281 0-1.6875-.7594-1.6875-1.6875zm8.5058-2.1817l-4.6366-4.63657C34.3028 6.17778 33.8736 6 33.426 6H33v6.75h6.75v-.426c0-.4476-.1778-.8768-.4942-1.1932z",
    fill: "#858199"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/iconCopy.87c6e173.svg";
export { ForwardRef as ReactComponent };